import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import ReturnGoods from "../../../../components/modules/warehouse/return-goods";
// middlewares
import ReturnGoodsMiddleware from "../../../../middleware/modules/warehouse/return-goods";
import i18n from "../../../../i18n";
import { Helmet } from "react-helmet";

const mapStateToProps = ({ auth, returnGoods }) => ({
  isProcessing: returnGoods.isProcessing,
  isError: returnGoods.isError,
  errorMessage: returnGoods.errorMessage,
  datalist: returnGoods.data,
  dataGoods: returnGoods.dataGoods,
  showModal: returnGoods.showModal,
  helper: returnGoods.takingGoodsHelper
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      approve: (id, value, search) => ReturnGoodsMiddleware.beforeApprove(id, value, search),
      reject: (id, value, search) => ReturnGoodsMiddleware.beforeReject(id, value, search),
      create: (search) => ReturnGoodsMiddleware.create(search),
      reset: () => ReturnGoodsMiddleware.resetList(),
      search: (data) => ReturnGoodsMiddleware.list(data),
      getDataGoods: (data) => ReturnGoodsMiddleware.getDataGoods(data),
      saveReturnGoods: (data) => ReturnGoodsMiddleware.beforeSaveReturn(data),
      getHelperFull: () => ReturnGoodsMiddleware.getHelperFull(),
    },
    dispatch
  );
};

class ReturnGoodsContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: {},
  };

  constructor(props) {
    super(props);
    this.createItem = this.createItem.bind(this);

  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.search(search);
  }

  getDataGoods(data){
    this.props.getDataGoods(data);
  }

  saveReturnGoods(data){
    this.props.saveReturnGoods(data);
  }

  createItem(search = null) {
    this.props.create(search);
    this.props.getHelperFull();
  }
  
  
  render() {
    const { isProcessing, search, datalist,authUser, dataGoods } = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Return Goods List")}
          </title>
        </Helmet>
        <ReturnGoods
          {...this.props} 
          authUser = {authUser}
          data={datalist}
          createItem={this.createItem}
        />
      </React.Fragment>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReturnGoodsContainer);
